import {
    OvertimePreviewItemDto,
    OvertimePreviewResultDto,
    OvertimePreviewStartDto,
} from '@clh/api-client';

export async function runOvertimePreview({
    start,
    fetchResult,
    wait,
    maxPolls = 60,
}: {
    start: () => Promise<OvertimePreviewStartDto>;
    fetchResult: (jobId: string) => Promise<OvertimePreviewResultDto>;
    wait: () => Promise<void>;
    maxPolls?: number;
}): Promise<OvertimePreviewItemDto[]> {
    const { jobId } = await start();
    if (!jobId) return [];

    for (let poll = 0; poll < maxPolls; poll++) {
        const result = await fetchResult(jobId);
        if (result.status === 'DONE') {
            return result.items;
        }
        if (result.status === 'FAILED') {
            throw new Error('OT preview failed');
        }
        await wait();
    }
    throw new Error('OT preview timed out');
}
